import React from 'react'
import { connect } from 'react-redux'
import { graphql } from 'gatsby'
import axios from 'axios'

import { Layout } from 'components'
import * as Boxes from 'components/theme/Boxes'
import { SEO, Hero } from 'components/common'
import * as UI from 'components/common/LayoutElements'
import * as Buttons from 'components/theme/Buttons'
import { SimpleBlock } from 'components/theme/Elements'
import { Badge } from 'components/theme'
import { PageWrapper, Section, RowSmallGap } from 'components/theme/Layout'
import { Content, Headline } from 'components/theme/Content'
import Testimonials from 'components/Testimonials';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import AOS from 'aos';
import * as Logos from 'components/theme/Logos'
import * as Cta from 'components/common/Cta'
import { handleSimulatorPresets } from 'actions/simulator'

import ContactForm from 'components/forms/enseignes/ContactForm'
import Modal from 'components/common/alerts/ModalDefault'
import { handleModal } from 'actions/modal'
// import Snackbar from '@material-ui/core/Snackbar'
// import { Notification } from 'components/common/alerts/SnackBars'

class Cavistes extends React.Component {

  constructor(props) {
    super(props);
    this.testimonials = [
      {
        name: 'Pauline D.',
        status: 'Laurent-Perrier',
        text: 'Nous avons réalisé 3 campagnes avec Message in a Window. 2 en caves qui se sont parfaitement déroulées avec un effet commercial bluffant. Nous avons prévu une nouvelle campagne en 2020.'
      },
      {
        name: 'Bruno B.',
        status: 'Ducru-Beaucaillou',
        text: 'Nous sommes très bons clients. Nous croyons aux caves et en Message in a Window. Les résultats sont très bons et nous continuons, nottament pour notre tricentenaire en 2020.'
      },
      {
        name: 'Antoine G.',
        status: 'Henriot',
        text: 'Les résultats ont dépassé nos attentes sur Canard-Duchêne, Joseph –Perrier, Thiénot et Dourthe. J’ai même signé des contrats annuels. Henriot avait choisi Message in a Window avant mon arrivée. Et bien sûr nous continuons!'
      },
      {
        name: 'Chloé S.',
        status: 'La Maison Du Whisky',
        text: 'Gros coup de cœur pour Message in a Window. Nous avons testé la solution avec The Dalmore à Paris. Nous avons ensuite déployé sur RedBreast, Flor de Caña et Nikka. MW est un formidable bras armé'
      },
      {
        name: 'Julie A.',
        status: 'Pacto Navio',
        text: `Nous avons activé Message In A window pour lancer le rhum Pacto Navio en caves. Il y a eu 65 implantations, 40000 € de commandes et 7,15M de vues. Un outil formidable et très qualitatif pour un lancement de produit.`
      }
    ];
    this.state = {
      page: null,
      pageTitle: null,
    }
    props.handleSimulatorPresets({ campaignType: 'trade', 'category': ['Caviste'] })
  }

  componentDidMount() {
    AOS.init({
      duration: 1000,
      once: true
    });
  }

  getResults = values => {
    const { API_ENDPOINT } = this.props.pageContext;
    values.page = 'enseignes';
    axios.post(`${API_ENDPOINT}/user/contact/`, {
      values
    }).then(res => {
      if (res.data.errors) {
        console.log('error');
      } else {
        this.setState({ notification: true });
      }
    })
  }

  handleModal = (id) => {
    this.setState({
      page: id,
      pageTitle: id === 'newsletter' ? 'Newsletter' : 'Étude de marché'
    });
    this.props.handleModal()
  }

  UNSAFE_componentWillReceiveProps() {
    AOS.refresh();
  }

  render() {

    const { pageContext, location, data } = this.props;
    const hero = data.backgrounds.edges.filter((item) => item.node.name === 'caviste_header')[0].node;
    const backgrounds = {
      'default': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_1')[0].node,
      'footer': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_2')[0].node,
      'testimonials': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'bg_testimonials')[0].node,
      'section7': data.backgrounds.edges.filter((item) => item.node.name === 'caviste_illu_1')[0].node
    };
    const logos = {
      'Ardbeg': data.__logos.edges.filter((item) => item.node.name === 'ardbeg')[0].node.publicURL,
      'Beluga': data.__logos.edges.filter((item) => item.node.name === 'beluga')[0].node.publicURL,
      'Dalmore': data.__logos.edges.filter((item) => item.node.name === 'dalmore')[0].node.publicURL,
      'Flor': data.__logos.edges.filter((item) => item.node.name === 'flor-de-cana')[0].node.publicURL,
      'Glenvilet': data.__logos.edges.filter((item) => item.node.name === 'glenlivet')[0].node.publicURL,
      'Glenmorangie': data.__logos.edges.filter((item) => item.node.name === 'glenmorangie')[0].node.publicURL,
      'Henriot': data.__logos.edges.filter((item) => item.node.name === 'henriot')[0].node.publicURL,
      'LaurentPerrier': data.__logos.edges.filter((item) => item.node.name === 'laurent-perrier')[0].node.publicURL,
      'Nikka': data.__logos.edges.filter((item) => item.node.name === 'nikka')[0].node.publicURL,
      'PactoNavio': data.__logos.edges.filter((item) => item.node.name === 'pacto-navio')[0].node.publicURL,
      'Pedesclaux': data.__logos.edges.filter((item) => item.node.name === 'pedesclaux')[0].node.publicURL,
      'Lavinia': data.__logos.edges.filter((item) => item.node.name === 'lavinia')[0].node.publicURL,
      'Nysa': data.__logos.edges.filter((item) => item.node.name === 'Nysa')[0].node.publicURL,
      'lqdm': data.__logos.edges.filter((item) => item.node.name === 'ldqm')[0].node.publicURL,
    }
    return (
      <Layout context={pageContext} location={location}>
        <SEO />
        <Hero image={hero.publicURL}>
          <div className="card">
            <SimpleBlock>
              <Badge className="grey blue">Cavistes</Badge>
            </SimpleBlock>
            <div>
              <h1>
                <span>
                  Activez plus de 4000 caves !
                </span>
              </h1>
            </div>
            <Content className="full padding xs">
              <p>
                Push de DN, renforcement des clients existants, lancement de produit,
                visibilité et notoriété grand public,
                Message in a Window peut devenir votre bras armé sur toute la France.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>NOUVEAU : Vous pouvez désormais travailler tout l'univers des cavistes sur <a style={{ color: 'white', textDecoration: 'underline' }} href="https://www.bottl.fr" target="_blank" rel="noopener noreferrer">Bottl.fr</a></strong>.
              </p>
            </Content>
            <Content className="full padding xs">
              <Buttons.ButtonDefaultLinkGatsby to="/simulation/">
                Faire une simulation
              </Buttons.ButtonDefaultLinkGatsby>
            </Content>
          </div>
        </Hero>

        <PageWrapper style={{ paddingTop: 0 }}>
          {/* Section 1 / section1 */}
          <Section className="no-margin main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
            padding: '10rem 0'
          }}>
            <div>
              <Boxes.BoxLargeShadow style={{ width: '100%' }} data-aos="fade-up">
                <div>
                  <Content className="center">
                    <h2><span>Êtes-vous confronté à ces enjeux ?</span></h2>
                  </Content>
                </div>

                <RowSmallGap className="centered">
                  <Boxes.BoxTiny className="bottom center fixed-height" style={{ paddingBottom: '7rem' }}>
                    <h3>Lancer<br /> un nouveau produit</h3>
                    <p>
                      Choisissez vos points de ventes pour lancer votre nouveau produit.
                    </p>
                    <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                      <Cta.ChevronFocusHref className="small" href="/pacto-navio/" title="Hero">
                        <span style={{ fontSize: '1.5rem' }}>Pacto Navio</span>
                      </Cta.ChevronFocusHref>
                    </div>
                  </Boxes.BoxTiny>
                  <Boxes.BoxTiny className="bottom center fixed-height" style={{ paddingBottom: '7rem' }}>
                    <h3>Activer <br />un temps fort</h3>
                    <p>
                      Choisissez les meilleurs moments de l'année pour augmenter la visibilité de votre marque.
                    </p>
                    <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                      <Cta.ChevronFocusHref className="small" href="/tullamore-dew" title="Hero">
                        <span style={{ fontSize: '1.5rem' }}>Tullamore Dew</span>
                      </Cta.ChevronFocusHref>
                    </div>
                  </Boxes.BoxTiny>
                  <Boxes.BoxTiny className="bottom center fixed-height" style={{ paddingBottom: '7rem' }}>
                    <h3>Renforcer <br />votre notoriété</h3>
                    <p>
                      Choisissez la + grande surface d'affichage urbaine et mesurez votre audience.
                    </p>
                    <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                      <Cta.ChevronFocusHref className="small" href="/glenmorangie/" title="Hero">
                        <span style={{ fontSize: '1.5rem' }}>Glenmorangie</span>
                      </Cta.ChevronFocusHref>
                    </div>
                  </Boxes.BoxTiny>
                  <Boxes.BoxTiny className="bottom center fixed-height" style={{ paddingBottom: '7rem' }}>
                    <h3>Augmenter <br />votre DN</h3>
                    <p>
                      Référencez vos produits dans de nouveaux points de vente.
                    </p>
                    <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                      <Cta.ChevronFocusHref className="small" href="/henriot/" title="Hero">
                        <span style={{ fontSize: '1.5rem' }}>Henriot</span>
                      </Cta.ChevronFocusHref>
                    </div>
                  </Boxes.BoxTiny>
                  <Boxes.BoxTiny className="bottom center fixed-height" style={{ paddingBottom: '7rem' }}>
                    <h3>Dynamiser <br />vos ventes</h3>
                    <p>
                      Aidez vos clients à vendre votre marque et vos produits.
                    </p>
                    <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                      <Cta.ChevronFocusHref className="small" href="/laurent-perrier/" title="Hero">
                        <span style={{ fontSize: '1.5rem' }}>Laurent-Perrier</span>
                      </Cta.ChevronFocusHref>
                    </div>
                  </Boxes.BoxTiny>
                </RowSmallGap>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>

          {/* Section 2 / section2 */}
          <Section className="bottom">
            <div>
              <Boxes.Box2Columns data-aos="fade-up">
                <div>
                  <Content>
                    <h3>Plus de 50 marques de vins, champagne, spiritueux ou interprofessions nous font confiance</h3>
                    <p>
                      <strong>De campagnes ponctuelles à des contrats annuels</strong>,
                      nous répondons à vos enjeux sur ce segment atomisé, parfois difficile d’accès.
                    </p>
                  </Content>
                </div>
              </Boxes.Box2Columns>

              <Boxes.Box2Columns data-aos="fade-up">
                <Logos.LogosContainer>
                  <Logos.LogoMedium
                    img={logos.Ardbeg}
                    top={-10}
                    left={0}
                    shadow={0.05}
                    size={70}
                    animationTime={5}
                  />
                  <Logos.LogoMedium
                    img={logos.Beluga}
                    top={170}
                    left={30}
                    shadow={0.03}
                    animationTime={6}
                  />
                  <Logos.LogoMedium
                    img={logos.Dalmore}
                    top={-60}
                    left={180}
                    shadow={0.03}
                    size={60}
                    animationTime={5.5}
                  />
                  <Logos.LogoMedium
                    img={logos.Flor}
                    top={150}
                    color="lightgrey"
                    left={380}
                    shadow={0.09}
                    animationTime={8}
                  />
                  <Logos.LogoLarge
                    img={logos.LaurentPerrier}
                    top={100}
                    left={180}
                    shadow={0.03}
                    animationTime={6}
                    size={70}
                  />
                  <Logos.LogoMedium
                    img={logos.Nikka}
                    top={280}
                    left={220}
                    shadow={0.03}
                    size={60}
                    animationTime={5}
                  />
                  <Logos.LogoMedium
                    img={logos.Pedesclaux}
                    color="blue"
                    top={0}
                    left={350}
                    shadow={0.1}
                    animationTime={2}
                  />
                </Logos.LogosContainer>
              </Boxes.Box2Columns>
            </div>
          </Section>

          {/* Section 3 / section3 */}
          <Section className="no-margin main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
            padding: '20rem 0 10rem'
          }}>
            <div>
              <Boxes.BoxLargeShadow className="cta" style={{ width: '100%' }} data-aos="fade-up">
                <div>
                  <Content>
                    <h2>Faites une simulation</h2>
                    <p>
                      Je simule le montage d’une campagne
                      <br />pour voir combien de vitrines je pourrais avoir
                      en fonction de mes critères...
                    </p>
                  </Content>
                </div>
                <Buttons.ButtonDefaultLinkGatsby
                  style={{
                    border: '1px solid white', color: 'white', background: 'transparent', marginTop: '4rem'
                  }}
                  to="/simulation/"
                >
                  Je démarre ma simulation
                </Buttons.ButtonDefaultLinkGatsby>
              </Boxes.BoxLargeShadow>

              <Boxes.BoxLarge style={{ width: '100%' }} data-aos="fade-up">
                <div>
                  <Content>
                    <h2 style={{ textAlign: 'center' }}>Découvrez le simulateur en vidéo avant de vous lancer</h2>
                    <div style={{
                      padding: '0 5rem 5rem', maxWidth: '100%', marginTop: '5rem', position: 'relative', display: 'flex'
                    }}>
                      <video
                        controls
                        style={{
                          margin: '0 auto',
                          outline: 'none',
                          display: 'inline-block',
                          maxWidth: '80rem',
                          boxShadow: '0 24px 32px 0 rgba(0,0,0,0.1), 0 8px 32px 0 rgba(0,0,0,0.1)'
                        }}>
                        <source
                          src="https://www.messageinawindow.com/videos/Trade cavistes V7.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </Content>
                </div>
              </Boxes.BoxLarge>
            </div>
          </Section>

          {/* Section 4 / section4 */}
          <Section className="bottom main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`
          }} data-aos="fade-up">
            <Headline className="center padding l">
              <h3>
                <span>
                  Regardez nos packs et gagnez encore plus de temps
                </span>
              </h3>
              <p>
                Pas le temps de monter une campagne sur-mesure ?
                <br /><span>Voici quelques exemples de packs.</span>
              </p>
            </Headline>

            <div>
              <Boxes.BoxTabs className="medium-title">
                <div>
                  <div className="tabs-cache"><div></div></div>
                  <Tabs defaultActiveKey="sc1_1" id="index">
                    <Tab eventKey="sc1_1" title="Hero 10">
                      <ul>
                        <li>
                          <h2>
                            <span><small>10 000 € HT</small></span>
                          </h2>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            10 vitrines (10 caves)
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Réservation 2 semaines
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Décor Hero
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            250€ HT* de commande produits garantis par commerce
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Fabrication et installation du décor
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Sondage commerçants
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Rapport de performance online avec photos et KPIs
                          </UI.BulletPointDefault>
                        </li>
                      </ul>
                    </Tab>
                    <Tab eventKey="sc1_2" title="Hero 25">
                      <ul>
                        <li>
                          <h2>
                            <span><small>23 000 € HT</small></span>
                          </h2>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            25 vitrines (25 caves)
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Réservation 2 semaines
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Décor Hero
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            250€ HT* de commande produits garantis par commerce
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Fabrication et installation du décor
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Sondage commerçants
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Rapport de performance online avec photos et KPIs
                          </UI.BulletPointDefault>
                        </li>
                      </ul>
                    </Tab>

                    <Tab eventKey="sc2_1" title="BigSho 10">
                      <ul>
                        <li>
                          <h2>
                            <span><small>22 000 € HT</small></span>
                          </h2>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            10 vitrines (10 caves)
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Réservation 2 semaines
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Décor BigSho
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            250€ HT* de commande produits garantis par commerce
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Fabrication et installation du décor
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Sondage commerçants
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Rapport de performance online avec photos et KPIs
                          </UI.BulletPointDefault>
                        </li>
                      </ul>
                    </Tab>
                    <Tab eventKey="sc1_4" title="BigSho 25">
                      <ul>
                        <li>
                          <h2>
                            <span><small>50 000 € HT</small></span>
                          </h2>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            25 vitrines (25 caves)
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Réservation 2 semaines
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Décor BigSho
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            250€ HT* de commande produits garantis par commerce
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Fabrication et installation du décor
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Sondage commerçants
                          </UI.BulletPointDefault>
                        </li>
                        <li>
                          <UI.BulletPointDefault>
                            Rapport de performance online avec photos et KPIs
                          </UI.BulletPointDefault>
                        </li>
                      </ul>
                    </Tab>
                  </Tabs>
                </div>
              </Boxes.BoxTabs>
            </div>
          </Section>

          {/* Section 5 / section5 */}
          <Section>
            <div>
              <Boxes.Box2Columns>
                <div>
                  <Content>
                    <h3>Les réseaux sont aussi prêts à vous accueillir</h3>
                    <p>
                      Les réseaux ont d’autres sortes d’atouts. Les activer en communiquant dans leurs
                      vitrines peut permettre de booster la relation et la prescription.
                    </p>
                    <p>
                      <span>Réservez des packs de 1, 5, 10 ou 25 vitrines par exemples sur vos temps forts.</span>
                    </p>
                  </Content>
                  <div style={{ marginTop: '4rem' }}>
                    <Cta.CtaDefaultButton
                      href={`https://messageinawindow.com/enseignes/`}
                      title="Message in a Window, plate-forme enseignes"
                    >
                      Accédez à la plateforme enseignes
                    </Cta.CtaDefaultButton>
                  </div>
                </div>
              </Boxes.Box2Columns>

              <Boxes.Box2Columns>
                <Logos.LogosContainer>
                  <Logos.LogoMedium img={logos.Lavinia} top={50} left={150} shadow={0.05} animationTime={2} />
                  <Logos.LogoLarge img={logos.Nysa} top={210} left={50} shadow={0.03} animationTime={4} />
                  <Logos.LogoMedium img={logos.lqdm} top={190} left={270} shadow={0.03} animationTime={3} />
                </Logos.LogosContainer>
              </Boxes.Box2Columns>
            </div>
          </Section>

          {/* Section 6 / section6 */}
          <Section>
            <Headline className="center padding l" data-aos="fade-up">
              <h2><span>Renforcez l'expérience</span></h2>
              <p>
                <span>Améliorez votre performance</span> en communiquant auprès de 4 000 cavistes via notre
                newsletter. Et recoltez tous les insights des cavistes via notre
                outil d'étude de marché.
              </p>
            </Headline>

            <div data-aos="fade-up">
              <Boxes.BoxFlex>
                <Boxes.BoxMedium>
                  <div>
                    <Content>
                      <h3>Communiquez dans notre newsletter</h3>
                      <p>
                        <br /><span>Vous lancez un produit ou avez une info intéressante à communiquer ?</span>
                      </p>
                      <p>
                        Nous envoyons une newsletter toutes les semaines à 4 400 cavistes,
                        avec un taux d’ouverture exceptionnel.
                      </p>
                      <p style={{ fontSize: '1.4rem', color: '#999' }}>
                        Nous pouvons inclure un lien vers votre site/blog/page Facebook
                        voire même vers notre outil de prise de commande produits!
                      </p>
                      <p style={{ paddingTop: '3rem' }}>
                        <span>Tarif: </span> à partir de 600€
                      </p>
                    </Content>
                    <div style={{ marginTop: '3rem' }}>
                      <Buttons.ButtonDefault
                        onClick={() => this.handleModal('newsletter')}
                        className="medium"
                      >
                        Ça m'intéresse
                      </Buttons.ButtonDefault>
                    </div>
                  </div>
                </Boxes.BoxMedium>
                <div>
                  <Boxes.Box2ColumnsShadow>
                    <h2><center>Article complet</center></h2>
                    <Boxes.BoxList className="offers">
                      <li>
                        <UI.BulletPointDefault>
                          Jusqu'à 3000 caractères
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          jusqu'à 5 images
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Rédaction par vos soins ou par nos rédacteurs
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Envoi à 4400 caves et épiceries fines
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Lien de redirection vers votre site
                        </UI.BulletPointDefault>
                      </li>
                    </Boxes.BoxList>
                  </Boxes.Box2ColumnsShadow>

                  <Boxes.Box2Columns>
                    <h2><center>Brève</center></h2>
                    <Boxes.BoxList className="offers">
                      <li>
                        <UI.BulletPointDefault>
                          250 caractères
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          1 image
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Rédaction par vos soins ou par nos rédacteurs
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Envoi à 4400 caves et épiceries fines
                        </UI.BulletPointDefault>
                      </li>
                    </Boxes.BoxList>
                  </Boxes.Box2Columns>
                </div>
              </Boxes.BoxFlex>
            </div>
          </Section>

          {/* Section 7 / section7 */}
          <Section className="bottom main" style={{
            background: `url(${backgrounds.section7.publicURL})`,
            backgroundSize: '100rem',
            backgroundPosition: 'bottom right',
            backgroundRepeat: 'no-repeat',
            padding: '10rem 0'
          }}>
            <div>
              <Boxes.BoxMediumShadow data-aos="fade-up">
                <Badge>étude de marché</Badge>
                <div>
                  <Content>
                    <h3>Interrogez les cavistes</h3>
                    <p>
                      <br /><span>Sondez les cavistes. Ils ont les réponses à vos questions.</span>
                    </p>
                    <p>
                      Nous réalisons des sondages online en 10 questions auprès des cavistes.
                      Vous lancez ou avez lancé un produit ? Voulez investir mais avez besoin de certitudes ?
                      Voulez obtenir des infos sur la concurrence ? Avez besoin d’avis ?
                    </p>
                    <p style={{ paddingTop: '3rem' }}>
                      <span>Tarif: </span>
                      1 800€ + 40€ / questionnaire.
                    </p>
                  </Content>
                  <div style={{ marginTop: '3rem' }}>
                    <Buttons.ButtonDefault
                      onClick={() => this.handleModal('etude-de-marche')}
                      className="medium"
                    >
                      Ça m'intéresse
                    </Buttons.ButtonDefault>
                  </div>
                </div>
              </Boxes.BoxMediumShadow>
            </div>
          </Section>

          {/* Section 8 / section8 */}
          <Section className="grey no-margin">

            <Headline className="center padding l" data-aos="fade-up">
              <h2>
                <span>Simplifiez-vous la vie</span>
              </h2>
              <p>
                <span>Optez pour un engagement annuel !</span>
              </p>
              <p>
                Déterminez une ligne de crédit à laquelle vous ou vos équipes avez accès pour des campagnes tactiques
                ou stratégiques.
              </p>
            </Headline>

            <div>
              <Boxes.BoxMedium className=" pricing min-height" data-aos="fade-up">
                <h2>
                  <center>
                    Window +<br />
                    <span>
                      <span>Engagement annuel de <br />50 000 € HT</span>
                    </span>
                  </center>
                </h2>
                <Boxes.BoxList className="offers" style={{ marginTop: '2rem' }}>
                  <li>
                    <UI.BulletPointDefault>
                      Concerne les campagnes newsletters, les sondages
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Honoraires à 16% vs 18%
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Commande minimum à 75% du montant reversé aux commerçants
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      1 brève dans votre newsletter adressées à 4400 cavistes
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      1 invitation à tous nos événements
                    </UI.BulletPointDefault>
                  </li>
                </Boxes.BoxList>
              </Boxes.BoxMedium>

              <Boxes.BoxMediumShadow className="pricing min-height" data-aos="fade-up">
                <h2>
                  <center>
                    Window Strong<br />
                    <span>
                      <span>Engagement annuel de <br />100 000 € HT</span>
                    </span>
                  </center>
                </h2>
                <Boxes.BoxList className="offers" style={{ marginTop: '2rem' }}>
                  <li>
                    <UI.BulletPointDefault>
                      Concerne les campagnes, les newsletters, l'habillage uniquement, les sondages
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Honoraires à 15% vs 18%
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Commande minimum obligatoire commerçants de 100% du montant qui leur est reversé
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      1 article + 1 brève dans notre newsletter adressées à 4400 cavistes
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      1 vidéo microtrottoir de 2'00 d'une des campagnes
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Buffer de 20% du montant total du contrat
                    </UI.BulletPointDefault>
                  </li>
                </Boxes.BoxList>
              </Boxes.BoxMediumShadow>

              <Boxes.BoxMedium className="pricing min-height" data-aos="fade-up">
                <h2>
                  <center>
                    Window Max <br />
                    <span>
                      <span>Engagement annuel de <br />200 000 € HT</span>
                    </span>
                  </center>
                </h2>
                <Boxes.BoxList className="offers" style={{ marginTop: '2rem' }}>
                  <li>
                    <UI.BulletPointDefault>
                      Concerne les campagnes, les newsletters, l'habillage uniquement, les sondages
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Honoraires à 15% vs 18%
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Commande minimum obligatoire commerçants de 100% du montant qui leur est reversé
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      2 articles + 2 brèves dans notre newsletter adressées à 4400 cavistes
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      2 vidéos microtrottoir de 2'00 d'une des campagnes
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Accès illimité aux fiches des 4400 caves sur www.caviste-advisor.com
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      5 invitations à tous nos événements
                    </UI.BulletPointDefault>
                  </li>
                  <li>
                    <UI.BulletPointDefault>
                      Buffer de 25% du montant total du contrat
                    </UI.BulletPointDefault>
                  </li>
                </Boxes.BoxList>
              </Boxes.BoxMedium>
            </div>
            <Content className="center">
              <Buttons.ButtonDefaultLink
                href="https://app.hubspot.com/meetings/achretien/1stcontact"
                target="_blank"
              >
                Parlons-en
              </Buttons.ButtonDefaultLink>
            </Content>
          </Section>

          {/* Section 9 / section9 */}
          <Section
            className="bottom"
            data-aos="fade-up"
            style={{
              backgroundImage: `url(${backgrounds.testimonials.publicURL})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top right',
              paddingBottom: '10rem'
            }}
          >
            <Testimonials data={this.testimonials} />
          </Section>

          <Modal title={this.state.pageTitle}>
            <div>
              <Content className="center">
                <h2>Laissez-nous vous recontacter</h2>
                <ContactForm
                  hubspotId={this.state.page === 'newsletter' ? `newsletterOfferForm` : `caseStudyForm`}
                  page={this.state.page}
                  onSubmit={this.getResults}
                />
                {/* <Snackbar
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  open={this.state.notification}
                  autoHideDuration={6000}
                  onClose={this.handleCloseNotification}
                >
                  <Notification
                    onClose={this.handleCloseNotification}
                    variant="success"
                    message="Votre demande a bien été prise en compte, nous vous recontactons rapidement."
                  />
                </Snackbar> */}
              </Content>
            </div>
          </Modal>

        </PageWrapper>
      </Layout>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleSimulatorPresets: (state) => dispatch(handleSimulatorPresets(state)),
  handleModal: () => dispatch(handleModal())
});
const mapStateToProps = (state) => ({
  ...state.contactForm
});
export default connect(mapStateToProps, mapDispatchToProps)(Cavistes);

export const query = graphql`
  query {
    backgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "pages/special-cavistes"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __commonBackgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "backgrounds/common"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __logos: allFile (
      filter: {
        relativeDirectory: {eq: "logos/cavistes"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
  }
`